const FieldLevel = Object.freeze({
    ITEM: 'item',
    ORDER: 'order',
});

module.exports = FieldLevel;
